//@flow
import * as React from 'react'
import onClickOutside from 'react-onclickoutside'

import css from './index.css'
import {resolveCss} from '$util'

type Props = {
  items: Array<{key: string | number, label: string | number}>,
  onChange: (value: string | number) => mixed,
  value: string | number
}

type State = {
  open: boolean
}

class SelectInput extends React.Component<Props, State> {
  state = {open: false}

  handleClickOutside = () => {
    this.setState({open: false})
  }

  toggle = () => this.setState({open: !this.state.open})

  onChange = (value: string | number) => () => {
    this.props.onChange(value)
  }

  render() {
    const classes = resolveCss(css)
    let activeLabel: ?string | ?number = undefined

    const selectItems = this.props.items.map(({key, label}, i) => {
      const currentActive = this.props.value === key

      if (currentActive) {
        activeLabel = label
      }

      return (
        <div
          key={i}
          onClick={this.onChange(key)}
          {...classes('listItem', currentActive && 'active')}
        >
          <p>{label}</p>
        </div>
      )
    })

    return (
      <div {...classes('container')} onClick={this.toggle}>
        <div {...classes('labelContainer')}>
          <p>{activeLabel}</p>
          <span {...classes('caret', this.state.open && 'invert')} />
        </div>
        {this.state.open && (
          <div {...classes('listContainer')}>{selectItems}</div>
        )}
      </div>
    )
  }
}

export default onClickOutside(SelectInput)



// WEBPACK FOOTER //
// ./src/common/components/SelectInput/index.js